<div class="course-item mb-4" id="{{ 'courses_div'+ course.id }}" [ngClass]="{'home-course': pageName == 'iit'}">
    <div class="course-featured-image" (click)="details(course)">
        <img [src]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>
    <div class="course-info-content">
        <h3 *ngIf="course.course_name.includes('.')" class="mb-0 px-3 py-2">{{course.course_name.split('.')[1]}}</h3>
        <h3 *ngIf="!course.course_name.includes('.')" class="mb-0 px-3 py-2">{{course.course_name}}
        </h3>

        <div class="course-text px-3 py-2 f-light">
            <p [innerHTML]="course.speciality | safeHtml"></p>
        </div>

        
    </div>
    <div *ngIf="course.display_only_one">
        <div class="c_footer d-flex p-2 mt-1 align-items-center">
            <div class="price_range mr-auto">
                <span class="mr-auto f-bold">
                    {{course.offer_price|currency}}</span>
                <small class="me-auto f-light mt-1" *ngIf="course.actual_price != course.offer_price"><del>
                        {{course.actual_price|currency}}</del></small>
            </div>
            <button class="btn f-bold p-2 text-white rounded-pill" (click)="buynow(course)">
                Course Structure & Discount
            </button>
        </div>
    </div>
</div>